/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldExistsFilterDefinition } from './fieldExistsFilterDefinition';


export interface LongRangeDeviceExternalRequestDto { 
    page?: number;
    count?: number;
    orderBy?: string;
    orderDirection?: string;
    deviceIdsFilter?: Array<number>;
    testDeviceFilter?: boolean;
    customerRefNoFilter?: Array<string>;
    batteryTypeIdFilter?: Array<string>;
    deviceTypeIdFilter?: Array<string>;
    firmwareVersionIdFilter?: Array<string>;
    parametersSet?: Array<string>;
    pcbTypeIdFilter?: Array<string>;
    customerContactFilter?: Array<string>;
    gpsPlusDeviceFilter?: boolean;
    replacedByIdFilter?: Array<number>;
    orderItemConfigurationIdFilter?: Array<string>;
    shippingDateBeforeFilter?: string;
    shippingDateAfterFilter?: string;
    genericFieldExistsFilter?: Array<Array<FieldExistsFilterDefinition>>;
    userSubsystemIdentifierVisibilityEnabled?: Array<number>;
    rmaIdFilter?: Array<string>;
    nameFilter?: string;
    userFilter?: Array<string>;
    keywords?: Array<string>;
    deviceManufacturingStatusFilter?: Array<LongRangeDeviceExternalRequestDto.DeviceManufacturingStatusFilterEnum>;
    comIdsFilter?: Array<string>;
    comTypeFilter?: Array<LongRangeDeviceExternalRequestDto.ComTypeFilterEnum>;
    networkStatusFilter?: Array<LongRangeDeviceExternalRequestDto.NetworkStatusFilterEnum>;
    dataPlanFilter?: Array<LongRangeDeviceExternalRequestDto.DataPlanFilterEnum>;
    paymentAccountFilter?: Array<number>;
    notificationAddressesFilter?: Array<string>;
    forwardingEmailAddressesFilter?: Array<string>;
    paymentAccountSearch?: Array<number>;
    airtimeNetworkStatusChangeRequestedFilter?: boolean;
    lastReceptionFromFilter?: string;
    lastReceptionToFilter?: string;
}
export namespace LongRangeDeviceExternalRequestDto {
    export const DeviceManufacturingStatusFilterEnum = {
        New: 'New',
        Assigned: 'Assigned',
        ReadyForTest: 'ReadyForTest',
        Testing: 'Testing',
        ManufacturingCompleted: 'ManufacturingCompleted',
        Packed: 'Packed',
        Shipped: 'Shipped',
        Canceled: 'Canceled',
        ManufacturingFailed: 'ManufacturingFailed'
    } as const;
    export type DeviceManufacturingStatusFilterEnum = typeof DeviceManufacturingStatusFilterEnum[keyof typeof DeviceManufacturingStatusFilterEnum];
    export const ComTypeFilterEnum = {
        Iridium: 'IRIDIUM',
        Globalstar: 'GLOBALSTAR',
        NbIot: 'NB_IOT',
        NoCommunication: 'NO_COMMUNICATION',
        Gsm: 'GSM'
    } as const;
    export type ComTypeFilterEnum = typeof ComTypeFilterEnum[keyof typeof ComTypeFilterEnum];
    export const NetworkStatusFilterEnum = {
        Activating: 'ACTIVATING',
        Activated: 'ACTIVATED',
        Deactivating: 'DEACTIVATING',
        Deactivated: 'DEACTIVATED',
        Suspending: 'SUSPENDING',
        Resuming: 'RESUMING',
        Changing: 'CHANGING',
        Invalid: 'INVALID',
        Changed: 'CHANGED'
    } as const;
    export type NetworkStatusFilterEnum = typeof NetworkStatusFilterEnum[keyof typeof NetworkStatusFilterEnum];
    export const DataPlanFilterEnum = {
        Unlimited: 'UNLIMITED',
        ThreeKbyte: 'THREE_KBYTE',
        SmithsonianSpecial: 'SMITHSONIAN_SPECIAL',
        PooledThreeKbyte: 'POOLED_THREE_KBYTE',
        PooledTwelveKbyte: 'POOLED_TWELVE_KBYTE',
        Test25Kbyte: 'TEST_2_5_KBYTE',
        Test4Kbyte: 'TEST_4_KBYTE'
    } as const;
    export type DataPlanFilterEnum = typeof DataPlanFilterEnum[keyof typeof DataPlanFilterEnum];
}


